// extracted by mini-css-extract-plugin
export default {"banner":"EbHKYuM_WCRgbxLiVzn2","bannerMessage":"OClwdqR_n56LnNSMTnJz","bannerIcon":"CiJW85dyqFQOfJ78RrC0","bannerUrl":"qXwmHCbtg6y89SC4Xd4e"};